"use client";

import { withFallback } from "../with-fallback";

export const DmsListElement = withFallback({
	displayName: "DmsListElement",
	type: "dms-list-element",
} as const);
